import React from 'react';

const Tag = (props: object) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.64625 8.64625C2.55266 8.55255 2.50006 8.42556 2.5 8.29313V2.5H8.29313C8.42556 2.50006 8.55255 2.55266 8.64625 2.64625L14.8538 8.85375C14.9474 8.94751 15.0001 9.07464 15.0001 9.20719C15.0001 9.33974 14.9474 9.46687 14.8538 9.56063L9.5625 14.8538C9.46874 14.9474 9.34161 15.0001 9.20906 15.0001C9.07651 15.0001 8.94938 14.9474 8.85563 14.8538L2.64625 8.64625Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.25 4.6875C5.56066 4.6875 5.8125 4.93934 5.8125 5.25C5.8125 5.56066 5.56066 5.8125 5.25 5.8125C4.93934 5.8125 4.6875 5.56066 4.6875 5.25C4.6875 4.93934 4.93934 4.6875 5.25 4.6875Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.125"
      />
    </svg>
  );
};

export default Tag;
